import { Controller } from '@hotwired/stimulus'
import { createCalendar, destroyCalendar, DayGrid, TimeGrid, ResourceTimeline, ResourceTimeGrid, List } from '@event-calendar/core';
import '@event-calendar/core/index.css';

export default class extends Controller {

  static values = {
    url: String,
    resourceUrl: String
  }

  connect() {
    const opts = {
      view: "resourceTimeGridDay",
      eventSources: [{
        url: this.urlValue,
      }],
      resources: (fetchInfo, successCallback, failureCallback) => {
        fetch(this.resourceUrlValue)
          .then(response => response.json())
          .then(data => successCallback(data))
          .catch(error => failureCallback(error));
      },
      refetchResourcesOnNavigate: true,
      eventTextColor: "#000000",
      height: "100%",
      headerToolbar: {
        start: "prev,next today",
        center: "title",
        end: "dayGridDay,dayGridWeek,dayGridMonth listDay,listWeek,listMonth,listYear resourceTimeGridDay,resourceTimeGridWeek resourceTimelineDay,resourceTimelineWeek,resourceTimelineMonth,resourceTimelineYear timeGridDay,timeGridWeek"
      }
    };

    console.log(opts);

    this.ec = createCalendar(
      this.element,
      [
        DayGrid,
        TimeGrid,
        ResourceTimeGrid,
        ResourceTimeline,
        List
      ],
      opts
    );
  }

  disconnect() {
    if(this.ec) destroyCalendar(this.ec);
  }

}
